/**
 * A forced page break.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readBoolean, readObject } from '@/domain/json'
import { NO_BACKGROUND, readBackground } from '@/domain/layout/background'
import { type PageBreakSection } from '@/domain/section'
import PageBreakBlock from '@/sections/pageBreak/PageBreakBlock.vue'
import PageBreakInspector from '@/sections/pageBreak/PageBreakInspector.vue'
import type { SectionDefinition } from '@/sections/types'

export const pageBreakSection: SectionDefinition<'pageBreak', PageBreakSection> = {
  kind: 'pageBreak',
  band: 'structure',

  icon: ['M3.5 2.5v3.5h9V2.5', 'M2 8h12', 'M3.5 13.5V10h9v3.5'],

  create: (id, title) => ({
    id,
    kind: 'pageBreak',
    title,
    background: NO_BACKGROUND,
    spread: false,
  }),

  // A stored break that says nothing about double pages opens a single page,
  // which is what its report was laid out on.
  read: ({ id, title, stored }) => ({
    id,
    kind: 'pageBreak',
    title,
    background: readBackground(readObject(stored, 'background')),
    spread: readBoolean(stored, 'spread'),
  }),

  block: PageBreakBlock,
  inspector: PageBreakInspector,
}
